import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href", "title"]
const _hoisted_2 = {
  key: 0,
  class: "m-listing-item__media"
}
const _hoisted_3 = { class: "m-listing-item__content" }
const _hoisted_4 = {
  key: 0,
  class: "m-listing-item__tag"
}
const _hoisted_5 = {
  key: 1,
  class: "m-listing-item__tag"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TpxImage = _resolveComponent("TpxImage")!
  const _component_TpxParagraph = _resolveComponent("TpxParagraph")!

  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(["m-listing-item", [_ctx.classes]]),
    href: _ctx.href,
    title: _ctx.heading
  }, [
    (_ctx.image)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.image)
            ? (_openBlock(), _createBlock(_component_TpxImage, _mergeProps({
                key: 0,
                class: ["m-listing-item__image", [_ctx.imageClasses]]
              }, _ctx.image), null, 16, ["class"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.type && _ctx.type !== 'Project')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.type), 1))
        : _createCommentVNode("", true),
      (_ctx.type && _ctx.type === 'Project')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.client), 1))
        : _createCommentVNode("", true),
      (_ctx.heading)
        ? (_openBlock(), _createBlock(_component_TpxParagraph, {
            key: 2,
            class: "m-listing-item__heading h6"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.heading), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}